import React from "react";
import TablePagination from "@material-ui/core/TablePagination";
import EATablePaginationActions from "./EATablePaginationActions";
import "../../styles/components/tablePagination.css";

/**
 * Komponente zur Darstellung der Paginierung
 * @param length Anzahl der dargestellten Daten
 * @param page
 * @param rowsPerPage
 * @param handleChangePage
 * @param handleChangeRowsPerPage
 * @returns {JSX.Element}
 * @constructor
 */
function EATablePagination({ length, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage }) {
    return (
        <table style={{ width: "100%", height: "53px", minHeight: "53px", borderCollapse: "collapse" }}>
            <tbody>
                <tr>
                    <TablePagination
                        className="tablePagination"
                        rowsPerPageOptions={[10, 25, 50]}
                        count={length}
                        rowsPerPage={rowsPerPage}
                        page={page * rowsPerPage > length ? 0 : page}
                        SelectProps={{
                            inputProps: { "aria-label": "rows per page" },
                            native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={EATablePaginationActions}
                        labelDisplayedRows={({ from, to, count }) => {
                            return `${from}-${to} von ${count}`;
                        }}
                        labelRowsPerPage="Ergebnisse pro Seite:"
                    />
                </tr>
            </tbody>
        </table>
    );
}

export default EATablePagination;
